import React from 'react';
import { motion } from 'framer-motion';

export default function EditorialQuote() {
  return (
    <section className="bg-ivory py-12 md:py-16 text-center overflow-hidden">
      <motion.div 
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="max-w-3xl mx-auto flex flex-col items-center px-6"
      >
        <div className="flex items-center justify-center gap-4 mb-4">
          <div className="w-8 h-[0.5px] bg-estate-gold/40"></div>
          <span className="text-estate-gold text-[8px]">✦</span>
          <div className="w-8 h-[0.5px] bg-estate-gold/40"></div>
        </div>
        
        <p className="font-serif italic text-lg md:text-2xl text-burgundy tracking-wide leading-relaxed">
          “Vows Beneath the Veranda This August in Claremont”
        </p>
        
        <div className="flex items-center justify-center gap-4 mt-4">
          <div className="w-8 h-[0.5px] bg-estate-gold/40"></div>
          <span className="text-estate-gold text-[8px]">✦</span>
          <div className="w-8 h-[0.5px] bg-estate-gold/40"></div>
        </div>
      </motion.div>
    </section>
  );
}